import React, { useState } from 'react';
import { useRoleVerify } from "Common/RoleVerify";
import { GetAll } from "adminApi/AboutUsApi/AboutUs";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/AboutUsField.json";

const AboutUsTable = () => {
  const [search, setSearch] = useState('');
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = fields;

  const { data, meta, loading, error, refetch } =
    usePaginatedFetch(GetAll, { page, limit, search: debouncedSearch, title: "About Us" });

  const displayFields = generateDisplayFields(tabledata);
  const { formattedData, columns } = useTableConfig({
    data,
    page,
    limit,
    canShowAction,
    refetch,
    IsDelete: false,
    config: {
      entityName: "About Us",
      editUrl: "edit-about-us",
      idKey: "id",
      deleteApi: () => { },
      displayFields,
    },
  });

  const handleSearch = (val, resetPage = null) => { setSearch(val); if (resetPage !== null) setPage(resetPage); };
  const onPageChange = p => setPage(p);
  const onLimitChange = newLimit => { setLimit(newLimit); setPage(1); };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading, error,
        sortableColumns: displayFields.map(f => f.accessor),
        copy: true, csv: true, pdf: true, print: true,
      }}
      Search={{ search: true, SearchInputValue: search, handleSearch }}
      Entries={{ Entries: true, limit, onLimitChange, options: sizeOptions }}
      pagination={{ isActive: true, meta, onPageChange }}
    />
  );
};

export default AboutUsTable;